import { render, staticRenderFns } from "./VkontakteButton.vue?vue&type=template&id=f81a79da&scoped=true&"
import script from "./VkontakteButton.vue?vue&type=script&lang=js&"
export * from "./VkontakteButton.vue?vue&type=script&lang=js&"
import style0 from "./VkontakteButton.vue?vue&type=style&index=0&id=f81a79da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81a79da",
  null
  
)

export default component.exports